<template>
  <nav :class="['primaryNav']">
    <ul ref="listWrap">
    	<li
      v-for="(item,index) in primaryNavArr"
      :class="['navitem',currentIndex === index? 'abc':'']"
      :key="index"
      @click="setScope(index)"
      >
      <!-- @click="tabScope(index)" -->
        <img v-if="item.IconUrl != null" :src="item.IconUrl" alt="">
        <img v-else src="../../assets/12.jpg" alt="">
        <span>{{item.ScopeTypeName}}</span>
      </li>
      <li>
        <img src="../../assets/12.jpg" alt="">
        <span>test</span>
      </li>
      <li>
        <img src="../../assets/12.jpg" alt="">
        <span>test</span>
      </li>
      <li>
        <img src="../../assets/12.jpg" alt="">
        <span>test</span>
      </li>
    </ul>
    <!-- <div class="direction-of-prompt-wrap">
      <i class="iconfont icon-xiangzuoshuangjiantou"></i>
      <i class="iconfont icon-xiangyoushuangjiantou"></i>
    </div> -->
  </nav>
</template>

<script>
  export default {
    name:'primary-nav',
    props:{
      primaryNavArr:{
        type: Array,
        required: true,
      },
    },
    data () {
      return {
        scopeId:0,
        currentIndex:0
      }
    },
    mounted () {
      // console.log(this.primaryNavArr);
      // this.scopeId=this.primaryNavArr[0].ID;
    },
    updated() {
      // this.setUlwidth();
    },
    methods:{
      //点击选择导航项目后 对应项目index 判断业务ID是否对应点击的主导航项目下的ID 传业务ID值到home组件
      setScope (index) {
        this.currentIndex = index;
        // console.log('primaryNavArr=>',this.primaryNavArr);
        if(this.scopeId != this.primaryNavArr[index].ID){
          // console.log(index);
          // console.log(this.currentIndex);
          // console.log(this.scopeId);
          this.scopeId = this.primaryNavArr[index].ID;
        }
        this.$emit("changedScopeId",this.scopeId);
      },

      setUlwidth(){
        var liWrap = this.$refs.listWrap,
            liitem = document.querySelectorAll('.primaryNav li');
        liWrap.style.width = liitem.length * 1.8 + "rem";
      }
    }

  }
</script>

<style scoped="scoped" lang="less">
  @import "../../style/variable.less";
  .primaryNav{
    max-width:100%;
    width: 90%;
    margin: 0 auto;
    overflow-x: auto;
    // &::-webkit-scrollbar{
    //   width: 20px;
    //   background-color: #fff;
    // }
    ul{
      .clearfix;
      overflow-x: hidden;
      background-color:#f8f8f8;
      // .flex_wrap(@fwVal:wrap);
      // .padding-Lr(0,.45rem);
      li{
        width: 1.8rem;
        float: left;
        text-align: center;
        // .flex_items(20%,0,0,wrap);
        .margin-Tb(.1rem);
        img{
          display: block;
          .margin-Tb();
          .wh(1.1rem,1.1rem);
          .radius(50%);
          .shadow(5px);
        }
        span{
          .text-style();
          display: inline-block;
          width: 4em;
          font-weight: 400;
          max-width: 4em;
          text-overflow: clip;
        }
      }
    }
//     .direction-of-prompt-wrap{
//       position: fixed;
//       left: 0;
//       width: 100%;
//       height: 100%;
//       z-index:100;
//       // .flex_wrap(space-between,center);
//       .iconfont{
//         position: absolute;
//         top: 50%;
//         transform: translateY(-50%);
//       }
//       .icon-xiangzuoshuangjiantou{
//         left: 0;
//       }
//       .icon-xiangyoushuangjiantou{
//         right: 0;
//       }
//
//     }
  }
  .active{
    border-bottom: 2px solid #E77618;
  }
</style>



// WEBPACK FOOTER //
// src/components/child-components/PrimaryNav.vue